export const warningMark = (medicine:Object) => {
    let result = '';
    if ((typeof medicine.poison !== 'undefined') && (medicine.poison == 1)) {
        result += '<span class="m-0.5 p-0.5 bg-black"><span class="text-xs text-white bg-black border border-white">毒</span></span>';
    } else if ((typeof medicine.dramatic_drug !== 'undefined') && (medicine.dramatic_drug == 1)) {
        result += '<span class="text-xs m-0.5 text-red-700 border border-red-700">劇</span>';
    } else if ((typeof medicine.hemp_drug !== 'undefined') && (medicine.hemp_drug == 1)) {
        result += '<span class="text-xs m-0.5 rounded-full text-red-700 border border-red-700">麻</span>';
    } else if ((typeof medicine.stimulant_drug !== 'undefined') && (medicine.stimulant_drug == 1)) {
        result += '<span class="text-xs m-0.5 text-black border border-black">覚醒</span>';
    } else if ((typeof medicine.stimulant_raw_material !== 'undefined') && (medicine.stimulant_raw_material == 1)) {
        result += '<span class="text-xs m-0.5 text-black border border-black">覚原</span>';
    } else if ((typeof medicine.psychotropic_drug !== 'undefined') && ((medicine.psychotropic_drug == 1) || (medicine.psychotropic_drug == 2) || (medicine.psychotropic_drug == 3))) {
        result += '<span class="text-xs m-0.5 rounded-full text-black border border-black">向</span>';
    } else if ((typeof medicine.temperature_limit !== 'undefined') && (medicine.temperature_limit != null) && (medicine.temperature_limit <= 15)) {
        result += '<span class="text-xs m-0.5 rounded-full text-blue-500 border border-blue-500">青</span>';
    }
    return result;
}
